// extracted by mini-css-extract-plugin
module.exports = {"colourSwatchesContainer":"colourSwatches-module__colourSwatchesContainer___3_3vY"};